import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Utils } from './utils';

/**
 * Accessible 404. No timed navigation: the visitor decides where to go (BLA-54 public
 * navigation contract).
 */
@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit, AfterViewInit {
  @ViewChild("containerRef") containerRef: ElementRef

  private readonly isBrowser: boolean

  public constructor(
    private readonly router: Router,
    private titleService: Title,
    @Inject(PLATFORM_ID) platformId: object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId)
  }

  public ngOnInit(): void {
    this.titleService.setTitle("Blauwtand — 404")
  }

  public async ngAfterViewInit(): Promise<void> {
    if (!this.isBrowser) return
    await Utils.timeout()

    window.addEventListener("scroll", () => {
      this.scrollFade()
    })
    this.scrollFade()
  }

  private scrollFade() {
    const container = this.containerRef?.nativeElement as HTMLElement | undefined

    if(container && container.getBoundingClientRect().y < window.innerHeight && container.classList.contains("scroll-fade")) {
      container.classList.remove("scroll-fade")
    }
  }

  public navigateTo(menuItem: string) {
    if(menuItem) {
      const lower = menuItem.toLowerCase()
      if (lower === 'home') {
        this.router.navigate(['/'])
      } else {
        this.router.navigate([`/${lower}`])
      }
    }
  }
}
